"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_native_1 = require("react-native");
const FastImageWeb = ({ ...rest }) => {
    return (0, jsx_runtime_1.jsx)(react_native_1.Image, { ...rest });
};
exports.default = FastImageWeb;
